import {
    PROFILES_FETCH,
    PROFILES_FETCH_ALL,
    PROFILES_IS_FETCING,
    PROFILES_API,
    PROFILE_EDIT,
    PROFILE_FILTER,
    SINGLE_PROFILE_FETCH
} from 'constants/profiles'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

//Save Propfiles
export const profileSave = (data) => (dispatch, state) => {
    let action;
    if (data.profileId)
        action = put;
    else
        action = post;
    if(data.baseProfile && data.defaultProfile){
        return Promise.reject('A profile based on default cannot be default profile!')
    }
    dispatch(profilesIsFetching(true))
    return action(PROFILES_API, data)
        .finally(e => dispatch(profilesIsFetching(false)))

}

export const profilesFetchAll = (data) => (dispatch, state) => {

    let params = {
            size: 1000000,
            sort: 'name,asc'
    }
    
    if(data && (data.hasOwnProperty('filter') && data.filter !== null)){
            params.filter = data.filter
    }


    return get(PROFILES_API, params)
        .then((e) => {
            dispatch(profilesFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                profileFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(profilesIsFetching(false)))
}

export const profilesFetchAllFilter = (profileName,loading=true) => (dispatch, state) => {

	dispatch(profilesIsFetching(loading));
    const filter = state().ibs.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])

    let params = {
            size: 1000000,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        }

    if(profileName) {
        params.nameFilter = profileName
    }

    return get(PROFILES_API, params)
        .then((e) => {
            dispatch(profilesFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                profileFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(profilesIsFetching(false)))
}

// this is fetching all profiles without saving them on redux store
export const profilesFetchAllHelper = (data) => (dispatch, state) => {

	let params = {
			size: 1000000,
            sort: 'name,asc'
	}

	if(data && (data.hasOwnProperty('filter') && data.filter !== null)){
			params.filter = data.filter
	}
	return get(PROFILES_API, params)
        .then((e) => {
            return e.content
        })
        //disable loading
        .finally(e => dispatch(profilesIsFetching(false)))
}

//Feth profile by id
export const profileFetch = (id) => (dispatch, state) => {
        dispatch(profilesIsFetching(true));
        return get(PROFILES_API + '/' + id)
            .then((p) =>{
                dispatch(fetchedSingleProfile(p))
                return p
            })
            .finally(e => dispatch(profilesIsFetching(false)))

}

//Feth all profiles
export const profilesFetch = (data) => (dispatch, state) => {
    dispatch(profilesIsFetching(true));
    const filter = state().profiles.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    let params = {
        size: filter.size,
        page: filter.page,
        sort: sorted + ',' + filter.sort[sorted]
    }

if(data && (data.hasOwnProperty('filter') && data.filter !== null)){
            params.filter = data.filter
        }
    

    return get(PROFILES_API, params)
        .then((e) => {
            dispatch(profilesFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                profileFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(profilesIsFetching(false)))
}

//Feth all profiles
export const profilesFetchIbs = (profileId, loading=true) => (dispatch, state) => {
    dispatch(profilesIsFetching(loading));
    const filter = state().profiles.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    let params = {
        size: filter.size,
        page: filter.page,
        sort: `name, ${filter.sort[sorted]}`
    }

    
    return get(PROFILES_API + '/' + profileId + '/ibtree',params)
        .then((e) => {
            dispatch(profilesFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                profileFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(profilesIsFetching(false)))
}

//Feth all profiles
export const profilesFetchFilter = (profileName, loading=true) => (dispatch, state) => {
    dispatch(profilesIsFetching(loading));
    const filter = state().profiles.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    let params = {
        size: filter.size,
        page: filter.page,
        sort: `name, ${filter.sort[sorted]}`
    }

    
    if(profileName) {
        params.nameFilter = profileName
    }

    return get(PROFILES_API, params)
        .then((e) => {
            dispatch(profilesFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                profileFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(profilesIsFetching(false)))
}


export const profilesAvailableFetch = () => (dispatch, state) => {
		dispatch(profilesIsFetching(true));
    const filter = state().profiles.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    return get(PROFILES_API+ '/available', {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        })
        .then((e) => {
            dispatch(profilesFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                profileFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(profilesIsFetching(false)))
}

//Remove one profile
export const profileRemove = (id) => (dispatch, state) => {
    dispatch(profilesIsFetching(true))
    return remove(PROFILES_API + '/' + id)
        //Array->Obj[profileId]{...profileinformation}
        //for easy access of profile by his id
        .finally(e => dispatch(profilesIsFetching(false)))
}

//Remove one profile
export const profileRemoveTreeNode = (id,ibId) => (dispatch, state) => {
    dispatch(profilesIsFetching(true))
    return remove(PROFILES_API + '/' + id + '/ibtree/' + ibId)
        //Array->Obj[profileId]{...profileinformation}
        //for easy access of profile by his id
        .finally(e => dispatch(profilesIsFetching(false)))
}
export const profilesFetched = (payload) => ({ type: PROFILES_FETCH, payload: payload })
export const profilesFetchedAll = (payload) => ({ type: PROFILES_FETCH_ALL, payload: payload })
export const profilesIsFetching = (payload) => ({ type: PROFILES_IS_FETCING, payload: payload })
export const profileEdit = (id, data) => ({ type: PROFILE_EDIT, payload: data })
export const profileFilter = (data) => ({ type: PROFILE_FILTER, payload: data })
export const fetchedSingleProfile = (data) => ({type: SINGLE_PROFILE_FETCH, payload: data})


// WEBPACK FOOTER //
// ./src/actions/profiles.js